// used for rendering the data analyzer menu items
// generated from the auto_mpg_final dataset
// https://github.com/aj-2000/autoapi/blob/main/App/datasets/auto_mpg_final.csv

export const MANUFACTURER_LIST = [
  "All",
  "Maruti",
  "Hyundai",
  "Honda",
  "Audi",
  "Nissan",
  "Toyota",
  "Volkswagen",
  "Tata",
  "Land",
  "Mitsubishi",
  "Renault",
  "MercedesBenz",
  "BMW",
  "Mahindra",
  "Ford",
  "Porsche",
  "Datsun",
  "Jaguar",
  "Volvo",
  "Chevrolet",
  "Skoda",
  "Mini",
  "Fiat",
  "Jeep",
  "Smart",
  "Ambassador",
  "Isuzu",
  "ISUZU",
  "Force",
  "Bentley",
  "Lamborghini",
];

export const MONTHS_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PROPERTIES_LIST = [
  "Name",
  "Manufacturer",
  "Year",
  "Fuel_Type",
  "Transmission",
  "Engine CC",
  "Power",
  "Seats",
  "Mileage Km/L",
  "Price",
  "AverageYearlySales",
];

export const Y_DATA_LIST = [
  "Year",
  "Engine CC",
  "Power",
  "Seats",
  "Mileage Km/L",
  "Price",
  "AverageYearlySales",
];

export const FUEL_TYPE_LIST = ["All", "CNG", "Diesel", "Petrol", "LPG"];

export const TRANSMISSION_LIST = ["All", "Manual", "Automatic"];

export const ORDER_BY_LIST = [
  "None",
  "Name",
  "Manufacturer",
  "Year",
  "EngineCC",
  "Power",
  "Seats",
  "Mileage",
  "Price",
  "AverageYearlySales",
];
